import React from 'react';

const ThemeContext = React.createContext({
    currentTheme: 'default',
    setTheme: () => {},
});

export default ThemeContext;
